<template>
    <div class="sentence_back">
        <img :src="geneNetworkPicture(objBackground.backgroundPicture)" class="big_cat_blur_backgroud"/>
        <div class="navigation" :style="{backgroundColor:'transparent', height:getNavCount()+'px', 'margin-top': isWeixinBrowser() ? '15px' : '0px'}">
            <div :style="{height:getStateHeight()+'px'}"></div>
            <div class="left" @click="goBack"><i class="icon-thin_back"/></div>
            <div class="right_post" :style="{'margin-top': getStateHeight()/2 + 'px'}" @click="nextClick">继续 ></div>
            <div class="clear"></div>
        </div>
        <div v-if="noShowGuideSlideCard === 0" class='popContainer' @click="guideSlideCardClick"><img
                src="../../assets/single_sentence.png"/></div>
        <Swiper v-if="wordCards.length > 0" ref="swiper" :autoPlay="false" :showIndicator="false"
                @transtionend="getNum" :style="{'margin-bottom': '60px'}" @observer="true" @observeParents="true">
            <Slide v-for="(item,index) in wordCards" :key="index">
                <div class="main_content">
                    <img class="img_show" v-lazy="$qiNiuDomainBase + item.picture"
                         @click="playAudio(item.audio)">
                    <div class="audio_playing img_play" :style="{display: isPlaying ? '' : 'none'}"></div>
                    <img class="img_play" :style="{display: isPlaying ? 'none' : ''}"
                         src="@/assets/word_course_volume3.png" height="30" width="30"/>

                    <div class="page_num">
                        {{index + 1}} / {{wordCards.length}}
                    </div>

                    <div class="english_interpretation"
                         v-if="!isEmpty(item.chineseAndEnglishInterpretation)"
                         @click="popupClick(index)">
                        <img src="@/assets/icon_english_english.png" height="15" width="15"/>
                        <span>中英解释</span>
                    </div>
                </div>
            </Slide>
        </Swiper>

        <audio v-bind:src="audioUrl" id="musicMp3" @ended="playEnded" @error="playEnded" autoplay="autoplay"
               controls=""/>

        <mt-popup
                v-model="popupVisible"
                popup-transition="popup-fade"
                class="popup_style">
            <div v-if="!isEmpty(interpretationContent)" @click="closePopup">
                <pre>{{interpretationContent}}</pre>
            </div>
        </mt-popup>

        <div class="sentence_sound_recording"
             :style="{position: judgePlatform() === 3 || judgePlatform() === 4 ? 'fixed' : 'relative'}">
            <div class="audio_record_anim recording" :style="{display: isRecording ? '' : 'none'}"
                 @click="endRecording"></div>
            <div v-if="noShowGuideRecord == 0" class="bubbleContainer" @click="guideRecordClick">
                <div class="text">点这里录音</div>
                <div class="img"><img src="../../assets/arrow_drop_right.png"/></div>
            </div>
            <div class="recording" :style="{display: isRecording ? 'none' : ''}" @click="startRecording"><img
                    src="../../assets/icon_record_audio.png"/></div>
            <div class="playing" :style="{display: isEmpty(currentSentenceUrl) ? 'none' : ''}"
                 @click="isPlayRecording ? playEnded() : playRecordAudio(currentSentenceUrl)">
                <img v-if="isPlayRecording" src="../../assets/icon_pause.png">
                <img v-else src="../../assets/icon_play.png"/></div>
        </div>
    </div>
</template>

<script>
    import wx from 'weixin-js-sdk';
    import {Swiper, Slide} from 'vue-swiper-component';
    import Vue from 'vue'
    import {Indicator, Toast} from "mint-ui";

    export default {
        name: "index",
        components: {
            Swiper,
            Slide
        },
        data() {
            return {
                lessonId: 0,
                cardIndex: 0,
                wordCards: [],
                screenWidth: document.body.clientWidth,
                audioUrl: "",
                interpretationContent: "",
                popupVisible: false,
                isPlaying: false,
                isRecording: false,
                isPlayRecording: false,
                tiemr: null,
                currentSentenceUrl: "",
                noShowGuideSlideCard: 1,
                noShowGuideRecord: 1,
                objBackground:{}
            }
        },
        mounted() {
            window.startCountDown = this.startCountDown;
        },
        methods: {
            judgePlatform: function () {
                let that = this;
                // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
                let Platform = 0;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (that.isWeixinBrowser()) {
                    // 微信平台
                    if (that.isAppIos()) {
                        Platform = 1;
                    } else {
                        Platform = 2;
                    }
                } else if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    // app平台
                    if (that.isAppIos()) {
                        Platform = 3;
                    } else {
                        Platform = 4;
                    }
                } else {
                    Platform = 0;
                }

                return Platform;
            },
            goToBack() {
                this.goBack(this.$router);
            },
            nextClick() {
                this.$router.push({name: "BWordlist", query: {lessonId: this.lessonId}});
            },
            getStateHeight: function () {
                return this.getCount(this.$store.state.statusheight);
            },
            getNavCount: function () {
                return this.getStateHeight() + 44;
            },
            guideSlideCardClick: function () {
                let that = this;

                if (that.noShowGuideSlideCard === 1) {
                    return;
                }

                that.$axios.get("bigCat/saveGuidePrompt/key3").then((response) => {
                    let vResult = that.getCount(response.data);

                    if (vResult === 1) {
                        that.noShowGuideSlideCard = 1;
                    }
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            guideRecordClick: function () {
                let that = this;

                if (that.noShowGuideRecord === 1) {
                    return;
                }

                that.$axios.get("bigCat/saveGuidePrompt/key4").then((response) => {
                    let vResult = that.getCount(response.data);

                    if (vResult === 1) {
                        that.noShowGuideRecord = 1;
                    }
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            suspendRecord() {
                let that = this;

                if (!that.isRecording) {
                    return;
                }

                let vPlatform = that.judgePlatform();
                let wordCard = that.wordCards[that.cardIndex];
                that.isRecording = false;

                if (vPlatform === 1 || vPlatform === 2) {
                    // 终止录音(1-微信IOS平台 2-微信android平台)
                    window.console.log("终止录音: 微信平台");
                    // 停止录音
                    that.isCountDowning = false;
                    wx.stopRecord({});
                } else if (vPlatform === 3) {
                    // 3-app平台IOS平台
                    window.console.log("终止录音: IOS平台");

                    let vUrl = "readingclubapp:suspendRecord:" + wordCard.pk + ":" + 3;
                    document.location = vUrl;
                } else if (vPlatform === 4) {
                    // 4-app平台android平台
                    window.console.log("终止录音: android平台");

                    window.note.suspendRecord(parseInt(wordCard.pk), 3);
                } else {
                    window.console.log("终止录音: 其它平台");
                    Toast("此浏览器不支持录音");
                }
            },
            startRecording() {
                let that = this;

                if (that.isRecording) {
                    return;
                }

                // 关闭引导页
                that.guideRecordClick();
                that.playEnded();
                let wordCard = that.wordCards[that.cardIndex];
                let vPlatform = that.judgePlatform();
                let second = 5;

                if (vPlatform === 1 || vPlatform === 2) {
                    // 开启录音(1-微信IOS平台 2-微信android平台)
                    window.console.log("开启录音: 微信平台");

                    wx.startRecord({
                        success: function (res) {
                            window.console.log(JSON.stringify(res));
                            that.isRecording = true;
                            that.startCountDown();
                        },
                        fail: function (res) {
                            window.console.log(JSON.stringify(res));
                            Toast('录音开启失败');
                        }
                    });
                } else if (vPlatform === 3) {
                    // 3-app平台IOS平台
                    window.console.log("开启录音: IOS平台");

                    let vUrl = "readingclubapp:startRecord:" + wordCard.pk + ":" + 3 + ":" + second + ":" + 0;
                    document.location = vUrl;
                } else if (vPlatform === 4) {
                    // 4-app平台android平台
                    window.console.log("开启录音: android平台");

                    window.note.startRecord(parseInt(wordCard.pk), 3, parseInt(second), 0);
                } else {
                    window.console.log("开启录音: 其它平台");
                    Toast("此浏览器不支持录音");
                }
            },
            sentenceStartRecordAnimation() {
                this.isRecording = true;
            },
            sentenceEndRecordAnimation() {
                this.isRecording = false;
                Indicator.open('上传中...');
            },
            sentenceCloseIndicator() {
                Indicator.close();
            },
            endRecording() {
                let that = this;
                that.isCountDowning = false;
                that.isRecording = false;
                let vPlatform = that.judgePlatform();
                let wordCard = that.wordCards[that.cardIndex];

                if (vPlatform === 1 || vPlatform === 2) {
                    // 关闭录音(1-微信IOS平台 2-微信android平台)
                    window.console.log("关闭录音: 微信平台");

                    // 停止录音
                    wx.stopRecord({
                        success: function (res) {
                            Indicator.open('上传中...');
                            window.console.log("停止录音：" + JSON.stringify(res));

                            // 上传音频到微信服务器
                            wx.uploadVoice({
                                localId: res.localId,
                                isShowProgressTips: 0,
                                success: function (uploadRes) {
                                    window.console.log(JSON.stringify(uploadRes));
                                    // 上传音频到其谬服务器
                                    that.saveUserAudio(uploadRes.serverId, uploadRes.localId, wordCard.pk, 0);
                                },
                                fail: function (uploadRes) {
                                    window.console.log(JSON.stringify(uploadRes));
                                    Indicator.close();
                                    Toast('录音上传失败');
                                }
                            });
                        },
                        fail: function (res) {
                            window.console.log(JSON.stringify(res));
                            Toast('录音停止失败');
                        }
                    });
                } else if (vPlatform === 3) {
                    // 3-app平台IOS平台
                    window.console.log("关闭录音: IOS平台");

                    let vUrl = "readingclubapp:stopRecord:" + wordCard.pk + ":" + 3;
                    document.location = vUrl;
                } else if (vPlatform === 4) {
                    // 4-app平台android平台
                    window.console.log("关闭录音: android平台");

                    window.note.stopRecord(parseInt(wordCard.pk), 3);
                } else {
                    window.console.log("关闭录音: 其它平台");
                    Toast("此浏览器不支持录音");
                }
            },
            saveUserAudio(mediaId, localId, cardId, sentenceId) {
                let that = this;
                let wordCard = that.wordCards[that.cardIndex];
                let url = "240words/recordingService/";

                that.$axios.post(url,
                    {type: 3, pk: wordCard.pk, mediaId: mediaId})
                    .then((response) => {
                        window.console.log("录音保存七牛：" + JSON.stringify(response.data));
                        Indicator.close();

                        if (response.data != null && response.data.code != -1) {
                            if (that.getCount(response.data.code) === 1) {
                                window.SLessonRefreshData = 1;
                            }

                            that.wordCards.forEach((item, index) => {
                                if (cardId === item.pk) {
                                    item.userAudio = response.data.audio;
                                    Vue.set(that.wordCards, index, item);
                                }
                            });

                            that.playRecordAudio2(response.data.audio, mediaId, false);

                            // 播放监听
                            wx.onVoicePlayEnd({
                                complete: function (res) {
                                    window.console.log("播放完成：" + JSON.stringify(res));
                                    that.playEnded();
                                }
                            });

                            // 播放录音
                            wx.playVoice({
                                localId: localId
                            });
                        } else {
                            Toast('录音上传失败');
                        }
                    });
            },
            startCountDown() {
                let that = this;
                let second = 5;
                this.isCountDowning = true;
                that.codeCountDown(second);
            },
            codeCountDown(second) {
                let that = this;
                let time = setTimeout(() => {
                    if (!this.isCountDowning) {
                        clearTimeout(time);
                        return;
                    }

                    clearTimeout(time);
                    that.endRecording();
                }, second * 1000);
            },
            popupClick(index) {
                let cardItem = this.wordCards[index];

                if (!this.isEmpty(cardItem.chineseAndEnglishInterpretation)) {
                    this.interpretationContent = cardItem.chineseAndEnglishInterpretation;
                    this.popupVisible = true;
                }
            },
            closePopup: function () {
                this.popupVisible = false;
            },
            playAudio(audio) {
                let that = this;
                that.suspendRecord();
                let musicMp3 = document.getElementById('musicMp3');

                if (that.isPlaying) {
                    musicMp3.pause();
                }

                that.audioUrl = that.$qiNiuDomainBase + audio;
                that.isPlaying = true;
                that.isPlayRecording = false;
                let playPromise = musicMp3.play();

                if (playPromise !== undefined) {
                    playPromise.then(() => {
                    }).catch((e) => {
                        let vError = JSON.stringify(e);

                        if (!that.isEmpty(vError) && vError != "{}") {
                            that.isPlaying = false;
                            window.console.log("播放失败:playAudio:" + JSON.stringify(e));
                        }
                    });
                } else {
                    that.isPlaying = false;
                    window.console.log("播放失败:playAudio");
                }
            },
            playStart() {
                this.isPlaying = true;
            },
            playEnded() {
                var musicMp3 = document.getElementById('musicMp3');
                musicMp3.pause();
                this.isPlayRecording = false;
                this.isPlaying = false;
            },
            sentencePlayRecordAudio(audio, finish, wordCardId, sentenceId) {
                // 句子完成
                let that = this;

                if (that.getCount(finish) === 1) {
                    window.SLessonRefreshData = 1;
                }

                that.wordCards.forEach((item, index) => {
                    if (wordCardId === item.pk) {
                        item.userAudio = audio;
                        Vue.set(that.wordCards, index, item);
                    }
                });

                let wordCard = that.wordCards[that.cardIndex];
                let vPlatform = that.judgePlatform();

                if (wordCardId === wordCard.pk) {
                    this.playRecordAudio2(audio, "", vPlatform !== 3);
                }
            },
            playRecordAudio(audio) {
                this.playRecordAudio2(audio, "", false);
            },
            playRecordAudio2(audio, wxMediaId, autoPlay) {
                let that = this;
                let musicMp3 = document.getElementById('musicMp3');

                if (that.isPlayRecording) {
                    musicMp3.pause();
                }

                that.audioUrl = that.$qiNiuDomainBase + audio;
                that.currentSentenceUrl = audio;

                window.console.log(that.audioUrl);
                that.isPlaying = false;
                that.isPlayRecording = true;

                if (!autoPlay && that.isEmpty(wxMediaId)) {
                    let playPromise = musicMp3.play();

                    if (playPromise !== undefined) {
                        playPromise.catch((e) => {
                            that.isPlayRecording = false;
                            window.console.log("播放失败:playRecordAudio2:" + e);
                        })
                    } else {
                        that.isPlayRecording = false;
                        window.console.log("播放失败:playRecordAudio2");
                    }
                }
            },
            getNum(data) {
                let that = this;

                //输出轮播到第几张图片
                if (data < that.wordCards.length) {
                    that.cardIndex = data;
                    let wordItem = that.wordCards[data];
                    that.playAudio(wordItem.audio);
                    that.currentSentenceUrl = wordItem.userAudio;
                }
            },
            wxRecordConfig(data) {
                let appId = data.appId;
                let timestamp = data.timestamp;
                let nonceStr = data.nonceStr;
                let signature = data.signature;

                wx.config({
                    debug: false,
                    appId: appId,
                    timestamp: timestamp,
                    nonceStr: nonceStr,
                    signature: signature,
                    jsApiList: [
                        'startRecord',
                        'stopRecord',
                        'onVoiceRecordEnd',
                        'playVoice',
                        'onVoicePlayEnd',
                        'pauseVoice',
                        'stopVoice',
                        'uploadVoice',
                        'downloadVoice',
                        'uploadImage']
                });
            }
        },
        created() {
            let that = this;
            // 客户端调用方法组
            window.sentenceStartRecordAnimation = that.sentenceStartRecordAnimation;
            window.sentenceEndRecordAnimation = that.sentenceEndRecordAnimation;
            window.sentencePlayRecordAudio = that.sentencePlayRecordAudio;
            window.sentenceCloseIndicator = that.sentenceCloseIndicator;

            // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
            if (that.isWeixinBrowser()) {
                this.$axios.post("fwh/getSignature", {
                    url: that.judgePlatform() === 1 ? window.location.protocol + "//" + window.location.host + "/" : window.location.href
                }).then((response) => {
                    that.wxRecordConfig(response.data);
                });
            }
        },
        beforeCreate() {
            let vlessonId = parseInt(this.$route.query.lessonId);
            let url = "bigCat/getWordCardInLesson/" + vlessonId;
            let that = this;

            this.$axios.get(url).then((response) => {
                that.wordCards = response.data;
                that.lessonId = vlessonId;
                that.cardIndex = 0;

                if (!that.isEmpty(that.wordCards)) {
                    let wordCard = that.wordCards[0];
                    that.audioUrl = that.$qiNiuDomainBase + wordCard.audio;
                    that.currentSentenceUrl = wordCard.userAudio;
                    that.noShowGuideSlideCard = that.getCount(wordCard.key3);
                    that.noShowGuideRecord = that.getCount(wordCard.key4);
                    that.objBackground = wordCard.background;
                }

                var t;
                clearTimeout(t);
                t = setTimeout(function () {
                    that.isPlaying = true;
                    window.SLessonRefreshData = 0;
                }, 200);
            }).catch(function (error) {
                window.console.log(error)
            });
        }
    }
</script>

<style scoped>
    .sentence_back {
        position: absolute;
        width: 100%;
        height: auto;
        min-height: 100%;
    }
    .navigation {
        position: relative;
    }
    .navigation .left {
        float: left;
        width: 50px;
        height: 44px;
        color: white;
        font-size: 25px;
        text-align: center;
        line-height: 50px;
    }
    .navigation .action_left {
        margin-left: 20px;
        height: 44px;
        float: left;
    }
    .navigation .action_left img {
        width:20px;
        float: left;
        margin-right:3px;
        margin-top: 13px;
    }
    .navigation .action_left span {
        float: left;
        line-height: 44px;
        font-size: 15px;
        color: white;
    }
    .navigation .right_post {
        width: 80px;
        height: 30px;
        float: right;
        position: absolute;
        right: 15px;
        top: 50%;
        -webkit-transform: translateY(-50%);
        border-radius: 13px;
        -webkit-border-radius: 13px;
        -moz-border-radius: 13px;
        background-color: #FFAA00;
        font-size: 16px;
        font-weight: bold;
        color: white;
        text-align: center;
        line-height: 30px;
    }

    .wrapper {
        width: 100%;
        height: auto;
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        flex-wrap: wrap;
    }

    .wrapper-content1 {
        width: 33%;
        text-align: center;
        margin-top: 20px;
    }

    .wrapper-content1 .wrapper_back {
        width: 100px;
        background-color: white;
        position: relative;
        left: 50%;
        -webkit-transform: translateX(-50%);
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
    }

    .wrapper-content {
        width: 33%;
        text-align: center;
        margin-top: 20px;
    }

    .wrapper-content1 img {
        width: 25px;
        height: 25px;
        margin-top: 5px;
        margin-bottom: 5px;
        margin-right: 10px;
        vertical-align: middle;
    }

    .wrapper-content img {
        width: 25px;
        height: 25px;
        margin-top: 5px;
        margin-bottom: 5px;
        margin-right: 10px;
        vertical-align: middle;
    }

    .wrapper-content1 span {
        height: 25px;
        color: #fda228;
        line-height: 25px;
        vertical-align: middle;
        font-size: 16px;
        font-weight: bold;
    }

    .wrapper-content span {
        height: 25px;
        color: white;
        line-height: 25px;
        vertical-align: middle;
        font-size: 16px;
        font-weight: bold;
    }

    .main_content {
        max-width: 560px;
        width: 100%;
        position: relative;
        left: 50%;
        -webkit-transform: translateX(-50%);
        margin-top: 30px;
    }

    .main_content .img_show {
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        width: calc(100% - 100px);
        margin: auto;
    }

    .main_content .img_play {
        position: absolute;
        right: 65px;
        top: 15px;
    }

    audio {
        display: none;
    }

    .main_content .page_num {
        margin-top: 10px;
        color: white;
        text-align: center;
        font-size: 17px;
    }

    .english_interpretation {
        position: absolute;
        right: 0px;
        margin-top: 10px;
        bottom: 2px;
    }

    .english_interpretation img {
        float: left;
        margin-top: 4px;
        margin-right: 5px;
    }

    .english_interpretation span {
        color: white;
        padding-right: 50px;
    }

    .popup_style {
        width: calc(100% - 60px);
        padding-left: 15px;
        padding-right: 15px;
        padding-top: 20px;
        padding-bottom: 20px;
        margin-right: 30px;
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
    }

    .popup_style pre {
        text-align: left;
        font-size: 20px;
        font-weight: bold;
        white-space: pre-wrap; /* css-3 */
        white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
        white-space: -o-pre-wrap; /* Opera 7 */
        word-wrap: break-word; /* Internet Explorer 5.5+ */
    }

    .sentence_sound_recording {
        width: 100%;
        height: 70px;
        bottom: 20px;
    }

    .sentence_sound_recording .recording {
        position: absolute;
        left: 50%;
        -webkit-transform: translateX(-50%);
    }

    .sentence_sound_recording .recording img {
        width: 70px;
        height: 70px;
    }

    .sentence_sound_recording .playing {
        position: absolute;
        right: 20px;
        top: 50%;
        -webkit-transform: translateY(-50%);
    }

    .sentence_sound_recording .playing img {
        width: 35px;
        height: 35px;
    }

    .audio_record_anim {
        width: 70px; /*宽高尺寸任意增减*/
        height: 70px;
        background: url(../../assets/record_audio_anim.png) no-repeat;
        background-size: 1000% 100%;
        -webkit-animation: line-slow 0.8s steps(9) infinite;
        animation: line-slow 0.8s steps(9) infinite;
    }

    @keyframes line-slow {
        0% {
            background-position: 0% 0%;
        }
        100% {
            background-position: 100% 0%;
        }
    }

    @-webkit-keyframes line-slow {
        0% {
            background-position: 0% 0%;
        }
        100% {
            background-position: 100% 0%;
        }
    }

    .popContainer {
        position: fixed;
        z-index: 10000;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
    }

    .popContainer img {
        position: absolute;
        left: 50%;
        top: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
        width: 70%;
        max-width: 400px;
    }

    .bubbleContainer {
        position: absolute;
        left: calc(50% - 99px);
        bottom: 21.5px;
        -webkit-transform: translateX(calc(50% - 99px));
    }

    .bubbleContainer .text {
        display: inline-block;
        color: #333333;
        background-color: white;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        padding: 3px 15px 3px 15px;
        font-size: 15px;
        font-weight: bold;
    }

    .bubbleContainer .img {
        position: absolute;
        top: 5px;
        right: -9px;
        display: inline-block;
        width: 15px;
    }

    .bubbleContainer .img img {
        width: 15px;
    }

</style>
